export default "__VITE_ASSET__4307c2e7__"